import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { displayToastSuccess } from '@/helpers';
import { useApiError } from '@/modules/common/hooks/use-api-error';

import { createOverhead } from '../api';
import { CreateProjectOverheadRequest } from '../types/dto/request/create-project-overhead.request';
import { invalidateOverheadsQueries } from './use-overheads-invalidation';

export const useCreateOverhead = ({ onSuccess }: { onSuccess?: () => void } = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('authenticated.overheads');
  const { displayToastErrorFromApiWithFallback } = useApiError();

  return useMutation({
    mutationFn: (data: CreateProjectOverheadRequest) => createOverhead(data),
    onSuccess: async () => {
      // Close the modal first, then toast — a toast popping over a still-open
      // modal looks broken. Invalidation last: it awaits the refetch and would
      // delay both.
      onSuccess?.();
      displayToastSuccess(t('toasts.createSuccess'));
      await invalidateOverheadsQueries(queryClient);
    },
    onError: error =>
      displayToastErrorFromApiWithFallback(error, 'authenticated.overheads:toasts.createError'),
  });
};
